'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.object.assign')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.clearDateObj = clearDateObj
exports.fillDateObj = fillDateObj
exports.cloneDateObj = cloneDateObj
exports.getFromDateObj = getFromDateObj
exports.setToDateObj = setToDateObj
exports.nullableDateObj = void 0

var _consts = _interopRequireDefault(require('./consts'))
var _getters = require('./getters')

var nullableDateObj = function nullableDateObj() {
  return {
    date: { y: null, M: null, d: null },
    time: { h: null, m: null, s: null }
  }
}
exports.nullableDateObj = nullableDateObj

function clearDateObj(dateObj) {
  _consts.default.dmyKeys.forEach(function(partName) {
    dateObj.date[partName] = null
  })
  _consts.default.hmsKeys.forEach(function(partName) {
    dateObj.time[partName] = null
  })
}

function fillDateObj(dateObj, date, hasSegments) {
  if (hasSegments.date) {
    dateObj.date = Object.assign({}, (0, _getters.getDmyFromDate)(date))
  }
  if (hasSegments.time) {
    dateObj.time = Object.assign({}, (0, _getters.getHmsFromDate)(date))
  }
  if (!hasSegments.seconds) {
    dateObj.time.s = null
  }
}

function cloneDateObj(dateObj) {
  return {
    date: {
      y: dateObj.date.y,
      M: dateObj.date.M,
      d: dateObj.date.d
    },

    time: {
      h: dateObj.time.h,
      m: dateObj.time.m,
      s: dateObj.time.s
    }
  }
}

function getFromDateObj(dateObj, partName) {
  switch (partName) {
    case 'd':
    case 'M':
    case 'y':
      return dateObj.date[partName]
    case 'h':
    case 'm':
    case 's':
      return dateObj.time[partName]
    default:
      return null
  }
}

function setToDateObj(dateObj, partName, val) {
  switch (partName) {
    case 'd':
    case 'M':
    case 'y':
      dateObj.date[partName] = val
      break
    case 'h':
    case 'm':
    case 's':
      dateObj.time[partName] = val
      break
    default:
      break
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/innerUtils.js
// module id = 220
// module chunks = 0